import { useFormikContext } from 'formik';
import { FormRow } from 'gossamer-front-end';
import { AbsenceReasonOptionType, Attendance, AttendanceRow } from 'cb-model';
import { OptionsField } from 'gossamer-unified';

interface ControlAbsenceReasonFieldProps {
  localAttendance: typeof Attendance;
}

export const ControlAbsenceReasonField = (props: ControlAbsenceReasonFieldProps): React.JSX.Element => {
  const { values } = useFormikContext<{ main: FormRow<AttendanceRow> }>();
  props.localAttendance.fields.absence_reason.editable = values.main?.attendance_result !== 'attended';
  if (values.main?.attendance_result === 'attended') {
    values.main.absence_reason = null;
  }
  (props.localAttendance.fields.absence_reason as OptionsField).options = (
    Attendance.fields.absence_reason as OptionsField
  ).options.filter((option) => {
    return (option as AbsenceReasonOptionType).result === values.main?.attendance_result;
  });
  return null;
};
